export const ZIPCODES_WADDENEILANDEN = [
  1790, 1791, 1792, 1793, 1794, 1795, 1796, 1797,
  8880, 8881, 8882, 8883, 8884, 8885, 8886, 8887, 8888, 8889,
  8890, 8891, 8892, 8893, 8894, 8895, 8896, 8897, 8899,
  9161, 9162, 9163, 9164, 9166,
];
export const DISCOUNT_DELIVERY_FROM_PRICE = 100;
export const FREE_DELIVERY_FROM_PRICE = 150;
export const SEND_COST = 8.95;
export const DISCOUNT_SEND_COST = 5.95;
export const CURRENCY = "€ ";
export const CURRENCY_CODE = "EUR";
export const DELIVERY_OPTIONS = {
  PICKUP: "pickup",
  SEND: "send",
};

export const PAYMENT_METHODS = {
  CREDITCARD: "creditcard",
  IDEAL: "ideal",
  BANCONTACT: "bancontact",
};

export const ADDRESS_TYPES = {
  DELIVERY: "DELIVERY",
  INVOICE: "INVOICE",
};
export const PICKUP_TIME_FROM = "13:00";
export const PICKUP_TIME_UNTIL = "16:00";
export const PICKUP_TIME_FROM_SATURDAY = "11:00";
export const PICKUP_TIME_UNTIL_SATURDAY = "15:00";
export const DELIVERY_TIME_FROM = "17:00";
export const DELIVERY_TIME_UNTIL = "22:00";
export const DELIVERY_TIME_FROM_SATURDAY = "08:00";
export const DELIVERY_TIME_UNTIL_SATURDAY = "18:00";
export const DELIVERY_DATE_WARNING_DAYS = 28;
export const SATURDAY_DELIVERY_COST_BELOW_150 = 9.99;
export const SATURDAY_DELIVERY_COST_ABOVE_150 = 4.99;
export const SATURDAY_DELIVERY_THRESHOLD = 150;
